import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { ChatSection } from "../utils/home/chat-section";
import { UserProfile } from "../utils/home/user-profile";
import { assetIcons, assetImages } from "../../constants/assets";
import FindMatchButton from "../utils/home/find-match-button";
import FindingMatchButton from "../utils/home/finding-match-button";
import LoadingModal from "../utils/popups/match-info-popup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fontSizes } from "../../theme/font-sizes";
import { darkColors } from "../../theme/colors";
import ActivitiesTable from "../utils/profile/activity-table";
import { MobileActivityCard } from "../utils/profile/mobile-activity-card";
import routes from "../../constants/routes";
import MatchFinder from "../utils/finding-match-timer";
import { useUser } from "../../context/user-context";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import LoadingBackdrop from "../utils/loader";
import { formatDaysAgo } from "../utils/date-formatter";

export default function UserProfileComponent() {
  // const activities = [
  //   {
  //     id: "1",
  //     name: "@ExHuma64",
  //     type: "bet",
  //     timestamp: "17 Minutes Ago",
  //     location: "Racer64",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "tokens", amount: 500 },
  //   },
  //   {
  //     id: "2",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },

  //   {
  //     id: "3",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "4",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "5",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "6",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "7",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "7",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "7",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   {
  //     id: "7",
  //     name: "@ExHuma64",
  //     type: "race",
  //     timestamp: "1 Hour Ago",
  //     location: "Deserted Land",
  //     odds: 2.32,
  //     status: "Won",
  //     earned: { type: "xp", amount: 35 },
  //   },
  //   // Add more mock data as needed
  // ];

  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const { makeApiCall } = useApiRequest();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const racerId = searchParams.get("racerId");
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [racerInfo, setRacerInfo] = useState(false);

  const fetchRacerProfile = async (showLoader = true) => {
    if (showLoader) setIsLoading(true);

    try {
      const response = await makeApiCall(
        apiRoutes.racer.details(racerId),
        "GET"
      );
      if (response?.data) {
        setRacerInfo(response.data.racerInfo);

        const racerOdds = response.data.winningDetails.map((data) => ({
          identifier: data.identifier,
          name: data.raceName,
          type: "race",
          timestamp: formatDaysAgo(data.winningTime),
          location: data.winningRaceName,
          totalWinning: data.totalWinning,
          // odds: data.racerOddFormatted,
          // avatar: data.racerPicture,
          status: "Won",
        }));
        setActivities(racerOdds);
      }
    } catch (error) {
      console.error("Failed to fetch user bets:", error);
    } finally {
      if (showLoader) setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRacerProfile();
  }, []);

  const handleNavigateToRace = (id) => {
    navigate(`${routes.race}?id=${id}`);

    // Perform navigation or additional logic if required
  };
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      <LoadingBackdrop isLoading={isLoading} />

      {/* Left side - scrollable content */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          m: isMediumScreen ? 0 : "15px",
          mt: 0,
          pt: 0,
          ml: isMediumScreen ? "auto" : "38px",
          height: "auto",
          //   bgcolor: "#1F1F1F",
          background: `linear-gradient(to bottom, #1F1F1F 0%, #0C0C0C 100%)`,

          mb: isMediumScreen ? 2 : 14,
          // mt: 4,
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
          },
        }}
      >
        <Box
          sx={{
            height: isMediumScreen ? "130px" : "200px",
            width: "100%",
            // backgroundImage: 'url("/placeholder.svg?height=200&width=1000")',
            backgroundImage: `url(${racerInfo?.coverUrl})`,
            backgroundSize: "100% 200%",
            // backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            // borderRadius: "8px 8px 0 0",
            mb: 2,
          }}
        />

        {/* Profile Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            mb: 4,
            ml: isMediumScreen ? 3 : 7,
            textAlign: "left",
          }}
        >
          <Avatar
            src={racerInfo?.photoUrl}
            sx={{
              width: isMediumScreen ? 88 : 100,
              height: isMediumScreen ? 88 : 100,
              border: "2px solid #f57c00",
              marginTop: "-70px",
            }}
          />
          <Typography
            fontFamily={"MontserratBold"}
            fontSize={fontSizes.superHeading5}
            sx={{ mt: 2, color: "white" }}
          >
            {racerInfo?.username}
          </Typography>
          {/* <Typography fontSize={fontSizes.body} sx={{ color: "grey.500" }}>
            80++ Winrate Racer, Highly Rated Racer, TOP 15%
          </Typography> */}
        </Box>

        <Divider
          sx={{
            my: isMediumScreen ? 3 : 1,
            mx: isMediumScreen ? 0 : 7,
            ml: isMediumScreen ? 3 : 0,
            background: darkColors.gray,
          }}
        />
        {isMediumScreen ? (
          <Stack pb={22} spacing={0}>
            {activities.map((activity, index) => (
              <MobileActivityCard
                key={activity.id}
                activity={activity}
                index={index}
              />
            ))}
          </Stack>
        ) : (
          <ActivitiesTable activities={activities} />
        )}
      </Box>

      {/* Right side - fixed content */}
      {!isMediumScreen && (
        <Box
          sx={{
            width: { lg: 370, sm: 300 },
            p: 3,
            height: "auto",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
            },
          }}
        >
          <UserProfile />
          <Box mt={3}></Box>
          <ChatSection />

          {/* Find Random Match Button */}
          <Box display={"flex"} justifyContent={"left"} mt={2} sx={{ mb: 11 }}>
            <MatchFinder
              onNavigate={handleNavigateToRace} // Custom navigation logic
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
